"use client";
import { j as e } from "./index.es176.js";
import { forwardRef as n, useMemo as t } from "react";
import { makeUniqueId as m } from "./index.es282.js";
n(
  ({ label: d, isChecked: o, onChange: r, isDefaultChecked: s, isDisabled: c, inputId: i, ...l }, h) => {
    const a = t(() => m(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-checkbox", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...l,
          ref: h,
          onChange: r,
          type: "checkbox",
          id: i || a,
          defaultChecked: s,
          disabled: c,
          checked: o
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: i || a, children: d })
    ] });
  }
);
//# sourceMappingURL=index.es178.js.map
